import { Box, Grid } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { ChangeEventHandler, useEffect, useState } from 'react';
import { CircularProgress, IconButton, InputAdornment, MenuItem, Paper } from "@mui/material";
import { Search } from "@mui/icons-material";
import MessageError from "../../../../../messages/messageError";
import apiCNP from "../../../../../services/apiCNP";

const useStyles = makeStyles({
  gridItem: { margin: 8 },
  formContainer: {
    padding: 16
  }
});

interface FormDataProps {
  formData: {
    unidadeSanitaria: string;
    provincia: string;
    municipio: string;
    distrito: string;
    bairro: string;
    rua: string;
    email: string;
  };
  handleChange: ChangeEventHandler<HTMLInputElement>;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  messageError: string;
  loading: boolean;
  show: boolean;
  buscarEstabelecimento: () => void;
}

interface Provincia {
  _id: string;
  designacao: string;
}

interface Municipio {
  _id: string;
  designacao: string;
}

export default function DadosUnidade({ formData, handleChange, messageError, setSearchTerm, searchTerm, buscarEstabelecimento, loading, show }: FormDataProps) {
  const classes = useStyles();
  const [provincias, setProvincias] = useState<Provincia[]>([]);
  const [municipios, setMunicipios] = useState<Municipio[]>([]);
  const [load, setLoad] = useState(false)

  useEffect(() => {
    apiCNP.get<{ provincias: Provincia[] }>('provincias')
      .then((response) => {
        setProvincias(response.data.provincias)
      })
      .catch(() => { setLoad(false) })
  }, [])

  const buscarMunicipio = (id_provincia: string) => {
    apiCNP.get<{ municipios: Municipio[] }>(`/municipios-by-provincia/${id_provincia}`)
      .then((response) => {
        setMunicipios(response.data.municipios)
      })
      .catch(() => setLoad(false))
  }
  return (
    <Box className={classes.formContainer}>
      {/* <Grid item xs={12}>
        <Paper sx={{ p: 2, mb: 2 }}>
          {messageError && <MessageError message={messageError} />}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="Número de Processo ou Autorização"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      disabled={loading || !searchTerm}
                      onClick={buscarEstabelecimento}
                    >
                      {loading ? <CircularProgress size={24} /> : <Search />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Paper>
      </Grid> */}

      {/* {show && */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              required
              type="text"
              label="Unidade sanitária / Farmácia"
              fullWidth
              size="small"
              name="unidadeSanitaria"
              variant="outlined"
              onChange={handleChange}
              value={formData.unidadeSanitaria}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              required
              type="text"
              select
              label="Província"
              fullWidth
              size="small"
              name="provincia"
              variant="outlined"
              onChange={handleChange}
              value={formData.provincia}
            >
              <MenuItem value={'Selecione a Província'}>
                Selecione a Província
              </MenuItem>
              {provincias.map((provincia) => (
                <MenuItem key={provincia._id} onClick={() => buscarMunicipio(provincia._id)} value={provincia.designacao} className='provincia'>
                  {provincia.designacao}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              disabled={municipios.length > 0 ? false : true}
              select
              required
              type="text"
              label="Município"
              fullWidth
              size="small"
              name="municipio"
              variant="outlined"
              onChange={handleChange}
              value={formData.municipio}
            >
              <MenuItem value={'Selecione o Município'}>
                Selecione o Município
              </MenuItem>
              {municipios.map((municipio) => (
                <MenuItem key={municipio._id} value={municipio.designacao}>
                  {municipio.designacao}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item  xs={12} md={6}>
            <TextField
              required
              type="text"
              label="Bairro"
              fullWidth
              size="small"
              name="bairro"
              variant="outlined"
              onChange={handleChange}
              value={formData.bairro}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              required
              type="text"
              label="Rua"
              fullWidth
              size="small"
              name="rua"
              variant="outlined"
              onChange={handleChange}
              value={formData.rua}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              required
              type="text"
              label="E-mail"
              fullWidth
              size="small"
              name="email"
              variant="outlined"
              onChange={handleChange}
              value={formData.email}
            />
          </Grid> 
        </Grid>
      {/* } */}
    </Box>
  );
}